<div class="fuse-card overflow-hidden" (click)="selectProduct(product?.id)">
  <div class="img-wrapper flex flex-col justify-center items-center">
    <img src="{{ getProductImagePath(product?.id) }}" />
  </div>

  <div class="p-4 pr-1">
    <span class="h2 three-line-clamp">{{ product?.name }}</span>
  </div>

  <div class="px-4 pb-4 mat-caption">
    <table>
      <tbody>
        <tr *ngIf="product?.processingMode === 0">
          <td class="secondary-text" i18n>Стоимость</td>
          <td>
            {{ product?.price | formatNumber : 2 | formatCurrency }}
          </td>
        </tr>
        <tr>
          <td class="secondary-text" i18n>Артикул</td>
          <td>
            {{ product?.article }}
          </td>
        </tr>
        <tr>
          <td class="secondary-text" i18n>Ширина</td>
          <td>
            {{ product?.widthRange }}
            <span i18n>мм</span>
          </td>
        </tr>
        <tr>
          <td class="secondary-text" i18n>Высота</td>
          <td>
            {{ product?.heightRange }}
            <span i18n>мм</span>
          </td>
        </tr>
        <tr>
          <td class="secondary-text" i18n>Глубина</td>
          <td>
            {{ product?.lengthRange }}
            <span i18n>мм</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
